import MenuSetPublishModal from './MenuSetPublishModal';

export default MenuSetPublishModal;
